import { render, staticRenderFns } from "./VotingQuiz.vue?vue&type=template&id=f681c458&scoped=true&"
import script from "./VotingQuiz.vue?vue&type=script&lang=js&"
export * from "./VotingQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f681c458",
  null
  
)

export default component.exports